import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'home-';

export default {
    path: '/home',
    name: 'home',
    redirect: {
        name: `${pre}console`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'console',
            name: `${pre}console`,
            meta: {
                ...meta,
                title: '数据总览',
                closable: false
            },
            component: () => import('@/pages/home/console')
        },
        {
            path: 'nfr',
            name: `${pre}nfr`,
            meta: {
                ...meta,
                title: 'NFR管理中心',
                closable: true
            },
            component: () => import('@/pages/home/nfr')
        }
    ]
};
